import * as React from 'react';
import { connect } from 'react-redux';
import { Link, RouteComponentProps } from 'react-router-dom';
import { Button, Row, Col, Label } from 'reactstrap';
import { AvForm, AvGroup, AvInput } from 'availity-reactstrap-validation';
// tslint:disable-next-line:no-unused-variable
import { Translate, translate, ICrudGetAction, ICrudGetAllAction, ICrudPutAction } from 'react-jhipster';
import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import { IRootState } from 'app/shared/reducers';

import { IEvent } from 'app/shared/model/event.model';
import { getEntities as getEvents } from 'app/entities/event/event.reducer';
import { getEntity, updateEntity, createEntity, reset } from './session.reducer';
import { ISession } from 'app/shared/model/session.model';
// tslint:disable-next-line:no-unused-variable
import { convertDateTimeFromServer } from 'app/shared/util/date-utils';
import { keysToValues } from 'app/shared/util/entity-utils';

export interface ISessionUpdateProps extends StateProps, DispatchProps, RouteComponentProps<{ id: number }> {}

export interface ISessionUpdateState {
  isNew: boolean;
  eventId: number;
}

export class SessionUpdate extends React.Component<ISessionUpdateProps, ISessionUpdateState> {
  constructor(props) {
    super(props);
    this.state = {
      eventId: 0,
      isNew: !this.props.match.params || !this.props.match.params.id
    };
  }

  componentDidMount() {
    if (this.state.isNew) {
      this.props.reset();
    } else {
      this.props.getEntity(this.props.match.params.id);
    }

    this.props.getEvents();
  }

  saveEntity = (event, errors, values) => {
    values.startTime = new Date(values.startTime);

    if (errors.length === 0) {
      const { sessionEntity } = this.props;
      const entity = {
        ...sessionEntity,
        ...values
      };

      if (this.state.isNew) {
        this.props.createEntity(entity);
      } else {
        this.props.updateEntity(entity);
      }
      this.handleClose();
    }
  };

  handleClose = () => {
    this.props.history.push('/entity/session');
  };

  eventUpdate = element => {
    const id = element.target.value.toString();
    if (id === '') {
      this.setState({
        eventId: -1
      });
    } else {
      for (const i in this.props.events) {
        if (id === this.props.events[i].id.toString()) {
          this.setState({
            eventId: this.props.events[i].id
          });
        }
      }
    }
  };

  render() {
    const isInvalid = false;
    const { sessionEntity, events, loading, updating } = this.props;
    const { isNew } = this.state;

    return (
      <div>
        <Row className="justify-content-center">
          <Col md="8">
            <h2 id="rtnApp.session.home.createOrEditLabel">
              <Translate contentKey="rtnApp.session.home.createOrEditLabel">Create or edit a Session</Translate>
            </h2>
          </Col>
        </Row>
        <Row className="justify-content-center">
          <Col md="8">
            {loading ? (
              <p>Loading...</p>
            ) : (
              <AvForm model={isNew ? {} : sessionEntity} onSubmit={this.saveEntity}>
                {!isNew ? (
                  <AvGroup>
                    <Label for="id">
                      <Translate contentKey="global.field.id">ID</Translate>
                    </Label>
                    <AvInput id="session-id" type="text" className="form-control" name="id" required readOnly />
                  </AvGroup>
                ) : null}
                <AvGroup>
                  <Label id="startTimeLabel" for="startTime">
                    <Translate contentKey="rtnApp.session.startTime">Start Time</Translate>
                  </Label>
                  <AvInput
                    id="session-startTime"
                    type="datetime-local"
                    className="form-control"
                    name="startTime"
                    value={isNew ? null : convertDateTimeFromServer(this.props.sessionEntity.startTime)}
                  />
                </AvGroup>
                <AvGroup>
                  <Label id="enabledLabel" check>
                    <AvInput id="session-enabled" type="checkbox" className="form-control" name="enabled" />
                    <Translate contentKey="rtnApp.session.enabled">Enabled</Translate>
                  </Label>
                </AvGroup>
                <AvGroup>
                  <Label for="event.id">
                    <Translate contentKey="rtnApp.session.event">Event</Translate>
                  </Label>
                  <AvInput id="session-event" type="select" className="form-control" name="event.id" onChange={this.eventUpdate}>
                    <option value="" key="0" />
                    {events
                      ? events.map(otherEntity => (
                          <option value={otherEntity.id} key={otherEntity.id}>
                            {otherEntity.id}
                          </option>
                        ))
                      : null}
                  </AvInput>
                  <AvInput id="session-event" type="hidden" name="event.id" value={this.state.eventId} />
                </AvGroup>
                <Button tag={Link} id="cancel-save" to="/entity/session" replace color="info">
                  <FontAwesomeIcon icon="arrow-left" />&nbsp;
                  <span className="d-none d-md-inline">
                    <Translate contentKey="entity.action.back">Back</Translate>
                  </span>
                </Button>
                &nbsp;
                <Button color="primary" id="save-entity" type="submit" disabled={isInvalid || updating}>
                  <FontAwesomeIcon icon="save" />&nbsp;
                  <Translate contentKey="entity.action.save">Save</Translate>
                </Button>
              </AvForm>
            )}
          </Col>
        </Row>
      </div>
    );
  }
}

const mapStateToProps = (storeState: IRootState) => ({
  events: storeState.event.entities,
  sessionEntity: storeState.session.entity,
  loading: storeState.session.loading,
  updating: storeState.session.updating
});

const mapDispatchToProps = {
  getEvents,
  getEntity,
  updateEntity,
  createEntity,
  reset
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = typeof mapDispatchToProps;

export default connect(mapStateToProps, mapDispatchToProps)(SessionUpdate);
